// Banners do guia "MEEM na prática" (produto pago do Ei, Doc!, R$ 47). Um componente, vários locais.
// PRIVACIDADE: nada do cálculo, da conta ou do prontuário entra na URL nem nos eventos; só o nome do local.
// Ligado por padrão; desligar com VITE_GUIA_BANNERS=off no ambiente de build.
export const GUIA_URL = 'https://eidoc.com.br/meem-na-pratica';
export const guiaBannersEnabled = () => import.meta.env.VITE_GUIA_BANNERS !== 'off';

export const GUIA_BANNER_PLACEMENTS = {
  'home-faixa': {
    texto: 'Deu um escore e ficou a dúvida do que fazer com ele? O guia MEEM na prática ensina a aplicar, interpretar com as referências brasileiras e acompanhar. PDF de 39 páginas, R$ 47.',
    cta: 'Conhecer o guia'
  },
  'resultado-rodape': {
    texto: 'Quer ler este número com mais segurança? O guia MEEM na prática traz as referências brasileiras, 8 casos e a ficha de registro. R$ 47.',
    cta: 'Conhecer o guia'
  },
  'guia-topo': {
    texto: 'Este tema em 39 páginas, com casos e ficha de registro: o guia MEEM na prática. PDF, R$ 47. O capítulo 1 é grátis.',
    cta: 'Ver o guia e ler o capítulo 1'
  },
  ficha: {
    texto: 'Usa a ficha para aplicar o teste? O guia MEEM na prática mostra como aplicar, pontuar e acompanhar com as referências brasileiras. O capítulo 1 é grátis.',
    cta: 'Ver o guia e ler o capítulo 1'
  },
  conta: {
    texto: 'Para quem aplica o MEEM todo dia: o guia MEEM na prática, com checklist, referências brasileiras e 8 casos. PDF, R$ 47.',
    cta: 'Conhecer o guia'
  },
  menu: { texto: '', cta: 'Guia' }
};

export function guiaBannerUrl(placement) {
  const url = new URL(GUIA_URL);
  url.search = new URLSearchParams({ src: 'minimental', utm_source: 'minimental', utm_medium: 'banner', utm_campaign: 'guia_' + placement }).toString();
  return url.toString();
}

export function captureGuiaBanner(event, placement) {
  window.eidocAnalytics?.capture(event, { placement });
}
